/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_01_Detail_Beginner_1_HeadingInputs */

const en_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why we start with the basics`)
};

const es_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por qué empezamos con lo básico`)
};

const de_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum wir mit den Grundlagen beginnen`)
};

const zh_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么我们从基础开始`)
};

const ar_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لماذا نبدأ بالأساسيات`)
};

const fr_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi nous commençons par les bases`)
};

const vi_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vì sao chúng ta bắt đầu với căn bản`)
};

const sw_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwa nini tunaanza na misingi`)
};

const th_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำไมเราจึงเริ่มจากพื้นฐาน`)
};

const bs_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zašto počinjemo s osnovama`)
};

const ja_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ基本から始めるのか`)
};

const ko_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`왜 기본부터 시작할까`)
};

const pt_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que começamos pelo básico`)
};

const it_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché partiamo dalle basi`)
};

const sv_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varför vi börjar med grunderna`)
};

const nl_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom we met de basis beginnen`)
};

const da_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor vi starter med det grundlæggende`)
};

const nb_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor vi starter med det grunnleggende`)
};

const fi_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miksi aloitamme perusasioista`)
};

const pl_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dlaczego zaczynamy od podstaw`)
};

const ru_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Почему мы начинаем с основ`)
};

const tr_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neden temellerle başlıyoruz`)
};

const hi_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हम बुनियादी बातों से क्यों शुरू करते हैं`)
};

const id_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengapa kita mulai dari dasar`)
};

const ms_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengapa kita bermula dengan asas`)
};

const cs_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proč začínáme od základů`)
};

const el_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γιατί ξεκινάμε από τα βασικά`)
};

const he_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`למה אנחנו מתחילים מהיסודות`)
};

const af_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom ons by die basiese begin`)
};

const hu_method_content_step_01_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miért az alapokkal kezdünk`)
};

/**
* | output |
* | --- |
* | "Why we start with the basics" |
*
* @param {Method_Content_Step_01_Detail_Beginner_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_01_detail_beginner_1_heading = /** @type {((inputs?: Method_Content_Step_01_Detail_Beginner_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_01_Detail_Beginner_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "de") return de_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "th") return th_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "it") return it_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "da") return da_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "id") return id_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "el") return el_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "he") return he_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "af") return af_method_content_step_01_detail_beginner_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_01_detail_beginner_1_heading(inputs)
	return en_method_content_step_01_detail_beginner_1_heading(inputs)
});